import { CollectionStore } from 'modules/base';

export class SelfDiscoveryQuestionsStore extends CollectionStore {
  baseUrl = '/self-discovery';
}
